import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { FlexRow } from '~pages/Sales/Orders/NewOrderForm/shared-components';

interface DrawerFooterProps {
  onCloseClick: () => void;
  sx?: SxProps<Theme>;
}

export default function DrawerFooter({ onCloseClick, sx }: DrawerFooterProps) {
  return (
    <Box sx={sx}>
      <FlexRow
        sx={(theme: Theme) => ({
          alignItems: 'center',
          borderTop: `solid 1px ${theme.palette.divider}`,
          height: '100%',
          justifyContent: 'flex-end',
          px: 2,
        })}
      >
        <SmallButton
          color="inherit"
          onClick={onCloseClick}
          variant="outlined"
          sx={(theme: Theme) => ({
            bgcolor: theme.semantic.surfaceRaised,
            border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          })}
        >
          {t('actions.close')}
        </SmallButton>
      </FlexRow>
    </Box>
  );
}
